import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/board/request/' // (3) 댓글 목록 조회

let swrData: any = getPersistData(KEY)

export function useBoardComment(postId) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY + postId + '/comment?page=1&maxData=99999999',
		async () => {
			const response = await API.get(KEY + postId + '/comment?page=1&maxData=99999999', token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		boardComment: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}